// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".help-dropdown{height:64px}.help-dropdown .help-dropdown-toggle{padding-top:13px;padding-bottom:13px}.help-dropdown .dropdown-menu{max-width:300px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
